import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatIconModule} from '@angular/material/icon';
import {MatListModule} from '@angular/material/list';
import {NgSelectModule} from '@ng-select/ng-select';
import {TranslateModule} from '@ngx-translate/core';
import {AvatarModule} from 'ngx-avatars';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import {PaginationModule} from 'ngx-bootstrap/pagination';
import {SharedModule} from '../../shared/shared.module';
import {MissionListCardComponent} from './mission-list/mission-list-card/mission-list-card.component';
import {MissionListComponent} from './mission-list/mission-list.component';
import {MissionRoutingModule} from './mission-routing.module';
import {MissionDetailComponent} from './mission-view/mission-detail/mission-detail.component';
import {
  ActivitiesViewDetailComponent,
} from './mission-view/mission-detail/section/activities-view-detail/activities-view-detail.component';
import {
  BillingViewDetailComponent,
} from './mission-view/mission-detail/section/billing-view-detail/billing-view-detail.component';
import {
  ProjectViewDetailComponent,
} from './mission-view/mission-detail/section/project-view-detail/project-view-detail.component';
import {
  ProviderViewDetailComponent,
} from './mission-view/mission-detail/section/provider-view-detail/provider-view-detail.component';
import {
  RequestPurchaseOrderDetailComponent,
} from './mission-view/mission-detail/section/request-purchase-order-detail/request-purchase-order-detail.component';
import {
  SupplierViewDetailComponent,
} from './mission-view/mission-detail/section/supplier-view-detail/supplier-view-detail.component';
import {
  TotalBillingsViewDetailComponent,
} from './mission-view/mission-detail/section/total-billings-view-detail/total-billings-view-detail.component';
import {MissionHistoryComponent} from './mission-view/mission-history/mission-history.component';
import {MissionViewComponent} from './mission-view/mission-view.component';


@NgModule({
  declarations: [
    MissionListComponent,
    MissionListCardComponent,
    MissionViewComponent,
    MissionDetailComponent,
    MissionHistoryComponent,
    ActivitiesViewDetailComponent,
    ProjectViewDetailComponent,
    SupplierViewDetailComponent,
    BillingViewDetailComponent,
    ProviderViewDetailComponent,
    TotalBillingsViewDetailComponent,
    RequestPurchaseOrderDetailComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MissionRoutingModule,
    PaginationModule,
    FormsModule,
    BsDatepickerModule,
    ReactiveFormsModule,
    AvatarModule,
    NgSelectModule,
    MatListModule,
    MatIconModule,
    TranslateModule
  ]
})
export class MissionModule {
}
